import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposOperacionSunat } from 'constants/index'

const TipoOperacionFormGroup = ({ fIsSubmitting, iError, iTouched }) => {
  return (
    <Form.Group>
      <Form.Label md={4} text='Tipo Operacion' alignRightAt='md' />
      <Col md={8}>
        <Field name='tipoOperacion'>
          {({ field }) => (
            <Form.Select {...field} id='select-tipoOperacion' isInvalid={iTouched && iError} disabled={fIsSubmitting}>
              <option value=''>Todos</option>
              {TiposOperacionSunat.__array.map(x => (
                <option key={x.id} value={x.id}>
                  {x.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoOperacionFormGroup)
